import { useCallback, useState } from 'react';

const useBindAction = (isStopAction, preventAction) => {
  const [storedAction, setStoredAction] = useState(null);

  const bindAction = useCallback(
    (action) => {
      if (isStopAction) {
        preventAction();
        setStoredAction(() => action);
        return;
      }

      action();
    },
    [isStopAction, preventAction],
  );

  const triggerAction = useCallback(() => {
    if (storedAction) {
      storedAction();
    }
    setStoredAction(null);
  }, [storedAction]);

  const resetAction = useCallback(() => {
    setStoredAction(null);
  }, []);

  return { triggerAction, bindAction, resetAction };
};

export default useBindAction;
